import TradebookToolbar from "./TradebookToolbar";
import TradebookTable from "./TradebookTable";
import TradebookGroup from "./TradebookGroup";
import useTradebook from "@/hooks/useTradebook";

export default function Tradebook({ trades }) {
  const {
    filteredTrades,
    groupedTrades,
    controls,
  } = useTradebook(trades);

  return (
    <>
      {/* Header (matches other card headers) */}
      <div className="mb-2 sm:mb-4">
        <h2 className="text-lg font-semibold text-foreground">
          Trade Book
        </h2>
      </div>

      {/* Toolbar */}
      <TradebookToolbar
        range={controls.range}
        setRange={controls.setRange}
        search={controls.search}
        setSearch={controls.setSearch}
        startDate={controls.startDate}
        setStartDate={controls.setStartDate}
        endDate={controls.endDate}
        setEndDate={controls.setEndDate}
        groupBy={controls.groupBy}
        setGroupBy={controls.setGroupBy}
        trades={filteredTrades}
      />

      {/* Content */}
      {filteredTrades.length === 0 ? (
        <div className="py-12 text-center text-sm text-muted-foreground">
          No trades for the selected period
        </div>
      ) : controls.groupBy ? (
        <TradebookGroup groupedTrades={groupedTrades} />
      ) : (
        <TradebookTable trades={filteredTrades} />
      )}
    </>
  );
}
